/**
 * Espelho dos enums do Prisma, para o frontend não precisar importar
 * @prisma/client. Se mudar no schema.prisma, muda aqui junto.
 */

// Sem Folga desde 18/10/2026 (ADR 0059): quem não está trabalhando fica Offline.
export const STATUS_USUARIO = ['online', 'pausado', 'offline'] as const
export type StatusUsuario = (typeof STATUS_USUARIO)[number]

export const ROTULO_STATUS_USUARIO: Record<StatusUsuario, string> = {
  online: 'Online',
  pausado: 'Pausado',
  offline: 'Offline',
}

/** Status que tiram o usuário do rodízio (4.7). */
export const STATUS_FORA_DO_RODIZIO: StatusUsuario[] = ['pausado', 'offline']

export const TIPO_CAMPO = [
  'texto',
  'numero',
  'data',
  'moeda',
  'lista',
  'multipla_escolha',
  'checkbox',
  'anexo',
] as const
export type TipoCampo = (typeof TIPO_CAMPO)[number]

/** De quem é o campo customizado (ADR 0069): da ficha do contato ou da empresa. */
export const ENTIDADE_CAMPO = ['contato', 'empresa'] as const
export type EntidadeCampo = (typeof ENTIDADE_CAMPO)[number]

export const TIPO_ETAPA = ['normal', 'ganho', 'perda'] as const
export type TipoEtapa = (typeof TIPO_ETAPA)[number]

export const STATUS_CONEXAO = ['conectado', 'desconectado', 'aguardando_qr'] as const
export type StatusConexao = (typeof STATUS_CONEXAO)[number]

export const STATUS_CHAMADO = ['aberto', 'fechado'] as const
export type StatusChamado = (typeof STATUS_CHAMADO)[number]

export const ORIGEM_CHAMADO = ['cliente', 'vendedor'] as const
export type OrigemChamado = (typeof ORIGEM_CHAMADO)[number]

export const MOTIVO_FECHAMENTO = ['manual_carteira', 'manual_fila', 'inatividade', 'bot'] as const
export type MotivoFechamento = (typeof MOTIVO_FECHAMENTO)[number]

export const DIRECAO_MENSAGEM = ['entrada', 'saida'] as const
export type DirecaoMensagem = (typeof DIRECAO_MENSAGEM)[number]

export const TIPO_MENSAGEM = [
  'texto',
  'imagem',
  'audio',
  'video',
  'documento',
  'sistema',
  'nota_interna',
] as const
export type TipoMensagem = (typeof TIPO_MENSAGEM)[number]

export const TIPO_TAREFA = ['ligacao', 'reuniao', 'mensagem', 'outro'] as const
export type TipoTarefa = (typeof TIPO_TAREFA)[number]

export const TIPO_NOTIFICACAO = [
  'tarefa',
  'cronometro',
  'sistema',
  /** Supervisão (5.6): vai para proprietário e administrador, não para o dono do chamado. */
  'sem_resposta',
  'fila_parada',
  /** Cliente escreveu para quem está fora, ou ficou na fila sem ninguém Online (08/10/2026). */
  'mensagem_para_fora',
  /** O cliente escreveu antes da mensagem programada sair: para quem agendou (08/10/2026). */
  'agendada_respondida',
  /** Retorno marcado, em verde na barra da direita até a hora chegar (08/10/2026). */
  'retorno_marcado',
  /** FaroEscolar Marketing (ADR 0057): post para aprovar, aprovado, reprovado, hora de publicar. */
  'marketing',
] as const
export type TipoNotificacao = (typeof TIPO_NOTIFICACAO)[number]
